<div mat-dialog-title class="dialog-title">
  <strong>{{ data.title }}</strong>
  @if (data.subtitle) {
    <span>{{ data.subtitle }}</span>
  }
</div>

<mat-dialog-content>
  @for (user of data.users; track user.id) {
    <div class="user-list-dialog-user">
      <app-user-profile-picture [user]="user" [alt]="user.full_name" [css_class]="'user-list-dialog-avatar'" />
      <div class="user-list-dialog-user-info">
        <span class="user-list-dialog-user-name">{{ user.full_name }}</span>
        @if (user.meta_label) {
          <span class="user-list-dialog-user-meta">{{ user.meta_label }}</span>
        }
      </div>
      @if (user.badges?.length) {
        <div class="user-list-dialog-badges">
          @for (badge of user.badges; track badge.label) {
            <span class="user-list-dialog-badge" [attr.data-kind]="badge.kind ?? 'role'" [attr.data-slug]="badge.slug ?? null">
              {{ badge.label }}
            </span>
          }
        </div>
      }
      @if (user.status_label && user.status) {
        <span class="status-badge" [attr.data-status]="user.status">{{ user.status_label }}</span>
      }
    </div>
  } @empty {
    <div class="user-list-dialog-empty">{{ data.empty_message ?? 'No hay usuarios asignados.' }}</div>
  }
</mat-dialog-content>
